import { FC, useState } from "react";
import { AuthBrandLogo } from "components/AuthBrandLogo";
import { Link } from "react-router-dom";
import { useResendVerifyEmail } from "hooks/useAuth";
import styled from "@emotion/styled";
import { Button, Col, Form, Input, message, Row, Typography, Result } from "antd";
import { MailOutlined } from "@ant-design/icons";

const ResendVerifyEmailPage: FC = () => {
  const [submitted, setSubmitted] = useState(false);
  const [form] = Form.useForm();

  const { mutate: requestResend, isPending } = useResendVerifyEmail();

  const handleSubmit = (values: { email: string }) => {
    requestResend(
      { email: values.email },
      {
        onSuccess: (data) => {
          if (data.status === "success") {
            setSubmitted(true);
            message.success(data.message || "ส่งลิงก์ยืนยันตัวตนเรียบร้อยแล้ว");
          } else {
            message.error(data.error_message || "เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง");
          }
        },
        onError: () => {
          message.error("เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง");
        },
      }
    );
  };

  return (
    <div style={{ minHeight: "100vh", backgroundColor: "#fff" }}>
      <Row gutter={[0, 0]}>
        <Col
          style={{ padding: 0 }}
          xs={{ span: 0 }}
          lg={{ span: 16 }}
          md={{ span: 16 }}
        >
          <BackgroundGradient>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "100vh",
              }}
            >
              <AuthBrandLogo />
            </div>
          </BackgroundGradient>
        </Col>
        <Col
          xs={{ span: 24, offset: 0 }}
          lg={{ span: 8, offset: 0 }}
          md={{ span: 8 }}
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            height: "100vh",
          }}
        >
          <SectionText>
            <Typography.Title level={4}>ขอลิงก์ยืนยันตัวตนใหม่</Typography.Title>
          </SectionText>
          <SectionText>
            <Typography.Text type="secondary">
              กรอกอีเมลที่ใช้ลงทะเบียน ระบบจะส่งลิงก์ยืนยันตัวตนและตั้งรหัสผ่านให้ท่านอีกครั้ง
            </Typography.Text>
          </SectionText>

          <SectionInput style={{ marginTop: 20 }}>
            {submitted ? (
              <Result
                icon={<MailOutlined style={{ color: "#1890ff" }} />}
                title="ส่งลิงก์เรียบร้อยแล้ว"
                subTitle="หากอีเมลนี้มีบัญชีที่รอการยืนยัน เราได้ส่งลิงก์ไปให้แล้ว กรุณาตรวจสอบกล่องจดหมาย (รวมถึงโฟลเดอร์สแปม)"
                extra={
                  <Button type="default" onClick={() => setSubmitted(false)}>
                    ส่งอีกครั้ง
                  </Button>
                }
              />
            ) : (
              <Form
                onFinish={handleSubmit}
                layout="vertical"
                form={form}
                style={{ display: "flex", flexDirection: "column", gap: 8 }}
              >
                <Form.Item
                  name="email"
                  rules={[
                    { required: true, message: "กรุณากรอกอีเมล" },
                    {
                      pattern: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                      message: "กรุณากรอกอีเมลที่ถูกต้อง",
                    },
                  ]}
                >
                  <Input placeholder="อีเมล" autoComplete="off" size="large" />
                </Form.Item>
                <Form.Item>
                  <Button
                    type="primary"
                    htmlType="submit"
                    style={{ width: "100%" }}
                    loading={isPending}
                    size="large"
                  >
                    ส่งลิงก์ยืนยันตัวตน
                  </Button>
                </Form.Item>
              </Form>
            )}

            <div style={{ textAlign: "center", marginTop: 16 }}>
              <Link to="/sign-in">กลับหน้าเข้าสู่ระบบ</Link>
            </div>
          </SectionInput>
        </Col>
      </Row>
    </div>
  );
};

export default ResendVerifyEmailPage;

const SectionText = styled.div`
  width: 100%;
  margin-top: 10px;
  text-align: center;
  padding: 0 5px;
`;

const SectionInput = styled.div`
  padding: 0 20px;
`;

const BackgroundGradient = styled.div`
  background: linear-gradient(45deg, #2777c8, #fff);
  width: 100%;
  height: 100vh;
`;
